<template>
  <div class="apresentacoes-adicionar">
    <v-container align-center justify-center class="container">
      <Card
        title="Criando Apresentação"
        text="Complete o formulário com as informações do evento"
        class="main-card"
      >
        <div class="infofield">
          <v-text-field label="Nome" filled v-model="nome"/>
          <v-text-field label="Organizador" filled v-model="organizador"/>
          <v-text-field label="Código Identificador" filled hint="Este código não será alterável posteriormente" v-model="codigo" :rules="[v => !!v || 'Este campo é obrigatório']"/>
        </div>
        <div class="infofield">
          <v-textarea label="Descrição" filled v-model="descricao"></v-textarea>
                <v-text-field
                  v-model="dataString"
                  label="Data"
                  filled
                  hint="Formato DD/MM/AAAA"
                ></v-text-field>
          <v-checkbox label="Confirmada" v-model="confirmedBox"/>
        </div>
        <div class="infofield">
          <v-divider/>
          <v-text-field label="Repertório (BETA)" hint="Separe as músicas com vírgula sem espaços" persistent-hint filled v-model="repertorioSerializado"/>
        </div>
        <v-btn v-on:click.native="save" color="success" class="mt-4">Salvar</v-btn>
      </Card>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { db, Timestamp } from '../main'
import Card from '@/components/Card.vue'

export default {
  name: 'adicionarapresentacao',
  components: {
    Card
  },
  watch: {
    dataapr (val) {
      this.dateFormatted = this.formatDate(this.dataapr)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    save: function (event) {
      if (!this.codigo.trim()) { // Checa se string está vazia
        console.log('Campo código identificador é obrigatório')
        alert('Campo Código Identificador é obrigatório')
        return
      }
      console.log('Verificando conflitos...')
      console.log(this.codigo)
      db.collection('apresentacoes')
        .where('codigo', '==', this.codigo)
        .get()
        .then(function (querySnapshot) {
          console.log(querySnapshot)
          if (!querySnapshot.empty) { // Já existe uma apresentação com o código identificador digitado
            console.log('Já existe uma apresentação com o código identificador digitado')
            alert('Já existe uma apresentação com o código identificador digitado')
          } else {
            console.log('Salvando...')
            const apresentacao = {}
            apresentacao.nome = this.nome
            apresentacao.codigo = this.codigo
            apresentacao.organizador = this.organizador
            apresentacao.confirmada = this.confirmedBox
            apresentacao.recusada = false
            apresentacao.descricao = this.descricao
            if (this.repertorioSerializado !== '') {
              apresentacao.repertorio = this.repertorioSerializado.split(',')
            }
            const tempDate = new Date(this.parseDate(this.dataString))
            tempDate.setUTCHours(3)
            apresentacao.data = Timestamp.fromDate(tempDate)
            db.collection('apresentacoes').doc(this.codigo).set(apresentacao).then(function () {
              console.log('Sucesso')
              this.$router.push({ name: 'Detalhes da Apresentação', params: { apresentacaoid: this.codigo } })
            }.bind(this)).catch(function (error) {
              console.error('Erro salvando documento: ' + error)
            })
          }
          // console.log('Salvo')
        }.bind(this))
      /*
      if (this.confirmedBox === false) aprSnapMod.confirmada = false
      else aprSnapMod.confirmada = true
      if (this.repertorioSerializado === '') {
        delete aprSnapMod.repertorio
      } else {
        aprSnapMod.repertorio = this.repertorioSerializado.split(',')
      }
      let tempDate = new Date(this.dataapr)
      tempDate.setUTCHours(3)
      if (this.dataapr !== '' && !aprSnapMod.dataprecisao) aprSnapMod.data = Timestamp.fromDate(tempDate)
      console.log(aprSnapMod)
      db.collection('apresentacoes')
        .doc(this.dbid)
        .set(aprSnapMod)
        .then(() => {
          console.log('Salvo')
          this.$router.push({ name: 'Detalhes da Apresentação', params: { apresentacaoid: this.apresentacaoid } })
        })
      */
    }
  },
  data () {
    return {
      nome: '',
      organizador: '',
      codigo: '',
      descricao: '',
      dataString: '',
      confirmedBox: false,
      menu1: false,
      dataapr: String,
      dateFormatted: '',
      repertorioSerializado: ''
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 800px;
}
</style>
